<template>
  <v-app-bar
    id="header"
    class="header"
    elevation="0"
    permanent
    scroll-behavior="elevate"
    height="54"
  >
    <div align-content="start" class="mr-2 ml-2 mt-2 pl-2 pr-15">
      <router-link :to="CONSTANTS.BASE_ROUTES.PROJECTLIST" :title="headerlogoTitle">
        <img
          class="mx-auto px-auto"
          height="40"
          width="127.51"
          :src="imgUrl"
          :alt="'Itemis Analyze'"
        />
      </router-link>
    </div>

    <div align-content="start">
      <v-row class="app-bar-items">
        <Breadcrumb />
      </v-row>
    </div>

    <v-spacer />
    <div align-content="end" class="pa-2 mr-2">
      <v-btn
        class="mr-2 help-btn"
        :icon="CONSTANTS.ICONS_MDI.ICON_HELP"
        density="comfortable"
        @click="openHelp"
      ></v-btn>
      <AvatarMenu :user-info />
    </div>
    <v-progress-linear :active="isLoading" :indeterminate="isLoading" absolute color="orange" />
  </v-app-bar>
</template>

<script lang="ts" setup>
  import CONSTANTS from '@/constants/Config.constants'

  import labels from '@/translations/labels.json'
  import { computed, watchEffect } from 'vue'
  import { useRouter } from 'vue-router'
  import { useUserStore } from '@/stores/modules/user'
  import Breadcrumb from '@/components/Breadcrumb/Breadcrumb.vue'
  import { useBaseStore } from '@/stores'
  import { storeToRefs } from 'pinia'
  import { AvatarMenu } from '@itemis-solutions/platform-web-components'
  import { useStore } from 'vuex'

  const imgUrl = new URL('/img/logo.svg', import.meta.url).href

  defineProps({
    headerlogoTitle: { type: String, required: true, default: '' },
    isHomepage: { type: Boolean, required: true, default: false },
    addBottomBorder: { type: Boolean, required: true, default: false },
  })

  const vuexStore = useStore()
  const userStore = useUserStore()
  const baseStore = useBaseStore()

  watchEffect(async () => {
    const token = vuexStore.state.oidcStore.access_token
    if (token) {
      try {
        await userStore.updateUserInfo()
      } catch (error) {
        throw new Error('Error updating user info:' + error)
      }
    }
  })
  const router = useRouter()
  const { getUserInfo: userInfo } = storeToRefs(useUserStore())

  const isLoading = computed((): boolean => {
    return baseStore.getLoadingState
  })

  function openHelp(): void {
    router.push({
      name: labels.HELP.TITLE,
    })
  }
</script>

<style lang="scss" scoped>
  @use '../../assets/styles/variables';
  .help-btn {
    background-color: #ffffff;
    color: #1a1a1a;
    border: 1px solid #000000;
  }

  .header {
    z-index: 4000 !important;
    border-bottom: #f59e00 solid 2px;
  }
</style>
